<p>timer-control works!</p>
